import { OtpContactChannel } from './otp-contact-channel.model';

export interface OtpContactModel {
  channel: OtpContactChannel;
  value: string;
  prefix?: string;
}
